import type { HeaderTab } from '@coorum-research/shared-common/api-response'
import { use } from 'react'
import { ThemeContext } from './ThemeContext'

type ButtonProps = {
  isActive: boolean
} & React.ComponentProps<'button'>

function Button({ isActive, ...props }: ButtonProps) {
  const { mainColor } = use(ThemeContext)
  return (
    <button
      type="button"
      className="flex-1 rounded p-1.5 text-center text-sm font-bold"
      style={{ backgroundColor: isActive ? mainColor : '#fff' }}
      {...props}
    />
  )
}

type MypageHeaderTabListProps = {
  tabs: HeaderTab[]
  mode: string
  onClick: (mode: string) => void
}

export function MypageHeaderTabList({ tabs, mode, onClick }: MypageHeaderTabListProps) {
  return (
    <div className="flex rounded-md bg-white p-1">
      {tabs.map(tab => (
        <Button key={tab.name} isActive={mode === tab.name} onClick={() => onClick(tab.name)}>{tab.label}</Button>
      ))}
    </div>
  )
}
